import { useNavigate } from 'react-router-dom';
import useInView from '../../../hooks/useInView';

const AcquisitionSection = () => {
  const navigate = useNavigate();
  const { ref: headerRef, inView: headerInView } = useInView();
  const { ref: cardsRef, inView: cardsInView } = useInView();

  return (
    <section id="acquisition" className="py-10 md:py-16 bg-[#EEF5FF]">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="max-w-3xl mx-auto text-center">
          <div
            ref={headerRef}
            className={`transition-all duration-700 ease-out ${headerInView ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-8'}`}
          >
            <p className="text-[#C41E3A] text-sm font-bold uppercase tracking-widest mb-3">Partnerships &amp; Acquisitions</p>
            <h2 className="text-2xl sm:text-3xl md:text-4xl lg:text-5xl font-bold text-[#111827] mb-5 sm:mb-6">
              Grow With Renova
            </h2>
            <p className="text-base sm:text-lg text-[#6B7280] mb-6 sm:mb-8 leading-relaxed">
              Renova partners with and acquires established home service companies and contractors. We provide the capital, technology, brand, and infrastructure. You bring the expertise and local relationships.
            </p>
          </div>

          <div ref={cardsRef} className="grid sm:grid-cols-3 gap-4 sm:gap-6 mb-8 sm:mb-10">
            {[
              { icon: 'ri-merge-cells-horizontal', title: 'Acquisition', desc: 'Full or partial acquisition of HVAC, plumbing, and electrical businesses in Florida.' },
              { icon: 'ri-handshake-line', title: 'Partnership', desc: 'Joint ventures and referral partnerships across Florida markets.' },
              { icon: 'ri-expand-diagonal-line', title: 'Scale Together', desc: 'Access to financing, brand, and operational infrastructure to grow faster in Florida.' },
            ].map((item, i) => (
              <div
                key={item.title}
                style={{ transitionDelay: `${i * 120}ms` }}
                className={`bg-white rounded-xl p-6 border border-[#E2E8F0] transition-all duration-700 ease-out ${cardsInView ? 'opacity-100 translate-y-0 scale-100' : 'opacity-0 translate-y-10 scale-95'}`}
              >
                <div className="w-12 h-12 bg-[#1A56A0]/10 rounded-lg flex items-center justify-center mx-auto mb-4">
                  <i className={`${item.icon} text-2xl text-[#1A56A0]`} />
                </div>
                <h3 className="text-base font-bold text-[#111827] mb-2">{item.title}</h3>
                <p className="text-sm text-[#6B7280]">{item.desc}</p>
              </div>
            ))}
          </div>

          <button
            onClick={() => navigate('/contact')}
            style={{ transitionDelay: '350ms' }}
            className={`bg-[#1A56A0] text-white px-8 py-4 rounded-lg text-base font-semibold hover:bg-[#154A8C] transition-all duration-700 ease-out whitespace-nowrap cursor-pointer ${cardsInView ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-6'}`}
          >
            Start the Conversation
          </button>
        </div>
      </div>
    </section>
  );
};

export default AcquisitionSection;
